export const HEADERS = [
    {
        label: 'calificar 5',
        value: 5,
    },
    {
        label: 'calificar 10',
        value: 10,
    },
    {
        label: 'calificar 20',
        value: 20,
    },
    {
        label: 'calificar 50',
        value: 50,
    },
];